import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSpecificationGroupProps } from '../@types/ProductSpecificationGroupProps';

export const ProductSpecificationGroupContext = createContext<ProductSpecificationGroupProps>(
	{} as ProductSpecificationGroupProps,
);

ProductSpecificationGroupContext.displayName = 'ProductSpecificationGroup';

const ProductSpecificationGroupProvider = (props: ProductSpecificationGroupProps) => (
	<ProductSpecificationGroupContext.Provider value={props}>{props.children}</ProductSpecificationGroupContext.Provider>
);

export const useProductSpecificationGroup = () => {
	const context = useContext(ProductSpecificationGroupContext);

	return context;
};

export default ProductSpecificationGroupProvider;
